import React from "react";
import {
  Award,
  Users,
  Building2,
  PenTool,
} from "lucide-react";

import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const stats = [
  {
    id: 1,
    icon: <Award size={30} />,
    number: 15,
    suffix: "+",
    title: "Years Experience",
  },
  {
    id: 2,
    icon: <Users size={30} />,
    number: 10000,
    suffix: "+",
    title: "Happy Customers",
  },
  {
    id: 3,
    icon: <Building2 size={30} />,
    number: 500,
    suffix: "+",
    title: "Corporate Clients",
  },
  {
    id: 4,
    icon: <PenTool size={30} />,
    number: 1000,
    suffix: "+",
    title: "Designs",
  },
];

const StatsSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.7,
  });

  return (
    <section className="stats-section">
      <style>{`
        .stats-section {
          background:
            linear-gradient(
              90deg,
              #050505 0%,
              #111111 50%,
              #050505 100%
            );

          position: relative;
          overflow: hidden;
          padding: 90px 0;
        }

        .stats-section::before {
          content: "";
          position: absolute;
          inset: 0;

          background:
            radial-gradient(
              circle at top left,
              rgba(252,115,3,0.10),
              transparent 30%
            ),
            radial-gradient(
              circle at bottom right,
              rgba(252,115,3,0.08),
              transparent 35%
            );

          pointer-events: none;
        }

        .stats-title {
          color: #fff;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 12px;
        }

        .title-line {
          width: 80px;
          height: 4px;
          background: #fc7303;
          border-radius: 20px;
          margin: 0 auto 50px;
        }

        .stat-card {
          background: rgba(255,255,255,0.04);

          backdrop-filter: blur(10px);

          border: 1px solid rgba(252,115,3,0.15);

          border-radius: 18px;

          padding: 30px 20px;

          height: 100%;

          text-align: center;

          transition: all 0.4s ease;

          position: relative;

          overflow: hidden;
        }

        .stat-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: -120%;

          width: 120%;
          height: 100%;

          background:
            linear-gradient(
              90deg,
              transparent,
              rgba(255,255,255,0.08),
              transparent
            );

          transition: 0.8s ease;
        }

        .stat-card:hover::before {
          left: 120%;
        }

        .stat-card::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;

          width: 0%;
          height: 3px;

          background: #fc7303;

          transition: 0.4s ease;
        }

        .stat-card:hover::after {
          width: 100%;
        }

        .stat-card:hover {
          transform: translateY(-8px);

          border-color: #fc7303;

          box-shadow:
            0 0 30px rgba(252,115,3,0.15);
        }

        .icon-box {
          width: 70px;
          height: 70px;

          border-radius: 50%;

          margin: 0 auto 20px;

          display: flex;
          align-items: center;
          justify-content: center;

          background: rgba(252,115,3,0.08);

          border: 1px solid rgba(252,115,3,0.15);

          color: #fc7303;

          transition: 0.4s ease;
        }

        .stat-card:hover .icon-box {
          background: #fc7303;
          color: #fff;

          transform: scale(1.08);
        }

        .stat-number {
          font-size: 2.4rem;
          font-weight: 800;
          color: #fff;
          margin-bottom: 8px;
        }

        .stat-card:hover .stat-number {
          color: #fc7303;
        }

        .stat-label {
          color: rgba(255,255,255,0.75);
          font-weight: 500;
          margin-bottom: 0;
        }

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .fade-up {
          animation: fadeUp 0.8s forwards;
        }

        @media (max-width: 768px) {

          .stats-section {
            padding: 70px 0;
          }

          .stat-card {
            padding: 22px 12px;
          }

          .icon-box {
            width: 55px;
            height: 55px;
          }

          .stat-number {
            font-size: 1.7rem;
          }

          .stat-label {
            font-size: 0.85rem;
          }
        }
      `}</style>

      <div className="container position-relative">
        <div className="text-center">
          <h2 className="stats-title">
            Our Achievements
          </h2>

          <div className="title-line"></div>
        </div>

        <div
          ref={ref}
          className="row g-4 justify-content-center"
        >
          {stats.map((item, index) => (
            <div
              key={item.id}
              className={`col-6 col-md-3 ${
                inView ? "fade-up" : ""
              }`}
              style={{
                animationDelay: `${index * 0.15}s`,
              }}
            >
              <div className="stat-card">
                <div className="icon-box">
                  {item.icon}
                </div>

                <h3 className="stat-number">
                  {inView ? (
                    <CountUp
                      start={0}
                      end={item.number}
                      duration={2.5}
                      separator=","
                    />
                  ) : (
                    0
                  )}
                  {item.suffix}
                </h3>

                <p className="stat-label">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;